import { types } from "../actions";

/**
 * Handles boolean states.
 * @param {Boolean} true || false
 * @param {Object} action created by an Action Creator
 * @returns {Boolean}
 */
export default function boolReducer(state, action) {
    //Unexpected state coming
    if (typeof state !== "boolean") return state;

    //Unexpected action
    if (!action || !action.type) return state;

    //Expected types
    switch (action.type) {
        case types.true:
            return true;
        case types.false:
            return false;
        case types.toggle:
            return !state;
        default:
            return state;
    }
}
